import { render, staticRenderFns } from "./supplyDetails.vue?vue&type=template&id=5bdc6908&scoped=true&"
import script from "./supplyDetails.vue?vue&type=script&lang=js&"
export * from "./supplyDetails.vue?vue&type=script&lang=js&"
import style0 from "./supplyDetails.vue?vue&type=style&index=0&id=5bdc6908&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc6908",
  null
  
)

export default component.exports